export const configurationURL = '/content/configuration'
